// test2393
(2393 && 0);
